/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {useTranslation} from 'react-i18next'
import axios from 'axios'
import {getParentAll, getDetailMenu, getIcon, getDetailJbpType} from '../../../../../api/modules/master-data/master_2'
import Pagination from '../../../component/Pagination'
import swal from 'sweetalert'
import {getAccessesMenu} from '../../../../../api/modules/access/access'
import {Spinner} from 'react-bootstrap'
import {RowFilter} from './RowFilter'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {exportJbpTypes, fetchJbpTypes, fetchMenus, headers} from '../../../../../services/fetcher'
import {objToParams} from '../../../../../utils/objToParams'
import {
  filterSelector,
  resetFilterMasterJBPType,
  resetFilterMenu,
  setFilterMasterJBPType,
  setFilterMenu,
  setIsFetchData,
} from '../../../../../redux/slices/filterSlices'
import {SelectPageSize} from '../../../../../components/SelectPageSize/SelectPageSize'
import {useRowTable} from '../../../../../hooks/useRowTable'
import * as TableUI from '../../../../../components/Table/Table'
import {StyledCard} from '../../../../../components/StyledCard'
import {StyledButtonGroups} from '../../../../../components/StyledButtonGroups'
import {HakAkses} from '../../../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'
import {SkeletonForm} from 'src/components/Skeletons'
import {ActionIcon} from 'src/components'
import {useLoaderList} from 'src/hooks/useLoaderList'
import { useSalesOrganization } from 'src/hooks/useSalesOrganization'
import i18next from 'i18next'

type Props = {
  className: string
}

const Table: React.FC<Props> = ({className}) => {
  const {roleId} = useAppSelector(authSelector)
  const {filterMasterJBPType: filterMenu} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const hakAkses = HakAkses()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 5,
    onReloadTable: () => handleResetTable(),
  })

  const {
    isLoadingEditButton,
    onInitializeLoaderList,
    onUpdateLoaderListByIndex,
    onResetLoaderList,
  } = useLoaderList()

  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleClose1 = () => setShow1(false)
  const handleShow1 = () => setShow1(true)

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)

  const [jbpTypes, setJbpTypes] = useState([])
  const [parent, setParent] = useState(null)
  const [page, setPage] = useState(0)
  const [per, setPer] = useState(0)
  const [loading, setLoading] = useState(true)
  const [numberURL, setNumberURL] = useState([])
  const [accesses, setAccesses] = useState(null)
  const [icon, setIcon] = useState(null)
  const [isError, setIsError] = useState(false)
  const [loadingExport, setLoadingExport] = useState(false)

  const rowNumber = useMemo(() => {
    const per = filterMenu?.per_page ?? 5
    return page * per - per
  }, [filterMenu, page])

  useEffect(() => {
    const getParent = async () => {
      setLoading(true)
      const res = await getParentAll()
      const data = res.data.data
      setParent(data)
      setPage(data.current_page)
      setPer(data.per_page)
      setLoading(false)
    }

    const getAccess = async () => {
      setLoading(true)
      const res = await getAccessesMenu(roleId)
      setAccesses(res.data.data)
    }

    const getIconList = async () => {
      setLoading(true)
      const res = await getIcon()
      setIcon(res.data.data)
    }

    getIconList()
    getAccess()
    getParent()
    // getMenu()
  }, [])

  const paginateNumber = async (url: string) => {
    try {
      setLoading(true)
      setIsError(false)

      const token = localStorage.getItem('token')
      const endpoint = `${url}&${objToParams({
        ...filterMenu,
        credentials: localStorage.getItem('credential')
      })}`
      const res = await axios.get(endpoint, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
          'X-Credentials': localStorage.getItem('credential')
        },
      })

      setJbpTypes(res.data.data.data)
      setPage(res.data.data.current_page)
      setNumberURL(res.data.data.links)
      onInitializeLoaderList(res.data.data.data)
    } catch (error) {
      setIsError(true)
    } finally {
      setLoading(false)
    }
  }
  
  const [isUpload, setIsUpload] = useState(false)

  const postJbpType = async () => {
    setBtnLoading(true)
    axios
      .post(
        `${process.env.REACT_APP_PI_BACKEND_API_MASTERDATA_V2}/price-list/jbp-type/create`,
        {
          company_code: salesOrgCode,
          company_desc: salesOrg,
          type: jbpType,
          lang: i18next.language
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'X-Credentials': localStorage.getItem('credential'),
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        setIsUpload(true)
        swal({
          title: `${t('Tipe JBP Berhasil di Tambahkan')}`,
          icon: 'success',
        })

        setSalesOrg('')
        setSalesOrgCode('')
        setJbpType('')
        handleClose()
        onFetchMenus()
      })
      .catch((error) => {
        swal({
          title: `${t(error.response.data.message)}`,
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const deleteMenu = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          axios
            .delete(`${process.env.REACT_APP_PI_BACKEND_API_MASTERDATA_V2}/price-list/jbp-type/delete/${id}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'X-Credentials': localStorage.getItem('credential'),
                apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                Accept: 'application/json',
                'Access-Control-Allow-Origin': '*',
              },
            })
            .then((response) => {
              setIsUpload(true)
              swal({
                title: `${t('Tipe JBP Berhasil di Hapus')}`,
                icon: 'success',
              })
                .then(() => {
                  setActived(!actived)
                  onFetchMenus()
                })
                .catch((error) => {})
            })
        }
      })
      .catch((error) => {
        swal({
          title: `${t('Data Failed to Delete')}`,
          icon: 'error',
        })
      })
  }

  const [editId, setEditId] = useState('')
  const [editName, setEditName] = useState('')
  const [editNameInd, setEditNameInd] = useState('')
  const [editSort, setEditSort] = useState('')
  const [editParent, setEditParent] = useState('')
  const [editParentMenu, setEditParentMenu] = useState('')
  const [editUri, setEditUri] = useState('')
  const [editIcon, setEditIcon] = useState('')
  const [editIconName, setEditIconName] = useState('')
  const [showSkeletonModal, setShowSkeletonModal] = useState(false)

  const handleEdit = async (id: any) => {
    try {
      handleShow1()

      setEditId(id)
      setShowSkeletonModal(true)

      const res = await getDetailJbpType(id)
      const data = res.data.data

      setEditCode(data.code)
      setEditSalesOrgCode(data.company_code)
      setEditSalesOrg(data.company_desc)
      setEditJbpType(data.type)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setShowSkeletonModal(false)
      onResetLoaderList()
    }
  }

  const editMenu = async () => {
    setBtnLoading(true)
    axios
      .put(
        `${process.env.REACT_APP_PI_BACKEND_API_MASTERDATA_V2}/price-list/jbp-type/edit/${editId}`,
        {
          company_code: editSalesOrgCode,
          company_desc: editSalesOrg,
          type: editJbpType,
          lang: i18next.language
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'X-Credentials': localStorage.getItem('credential'),
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        setIsUpload(true)
        swal({
          title: `${t('Tipe JBP Berhasil di Ubah')}`,
          icon: 'success',
        })
        handleClose1()
        setActived(!actived)
        onFetchMenus()
      })
      .catch((error) => {})
      .finally(() => {
        setBtnLoading(false)
      })
  }

  //#region state for search
  const [actived, setActived] = useState(false)

  const onFetchMenus = useCallback(() => {
    setLoading(true)
    setIsError(false)
    fetchJbpTypes(filterMenu)
      .then((res) => {
        setJbpTypes(res.data.data.data)
        setPage(res.data.data.current_page)
        setNumberURL(res.data.data.links)
        onInitializeLoaderList(res.data.data.data)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterMenu])

  useEffect(() => {
    const getData = setTimeout(onFetchMenus, 1000)
    return () => clearTimeout(getData)
  }, [onFetchMenus])
  //#endregion

  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setFilterMasterJBPType({...filterMenu, per_page: value ?? 5}))
  }

  const {salesOrgOptions} = useSalesOrganization(true)
  const [salesOrg, setSalesOrg] = useState('')
  const [salesOrgCode, setSalesOrgCode] = useState('')
  const [jbpType, setJbpType] = useState('')

  const [editCode, setEditCode] = useState('')
  const [editSalesOrg, setEditSalesOrg] = useState('')
  const [editSalesOrgCode, setEditSalesOrgCode] = useState('')
  const [editJbpType, setEditJbpType] = useState('')

  const handleSalesOrg = (e) => {
    let index = e.nativeEvent.target.selectedIndex;
    let label = e.nativeEvent.target[index].text;
    
    setSalesOrgCode(e.target.value)
    setSalesOrg(label)
  }
  const handleSalesOrgEdit = (e) => {
    let index = e.nativeEvent.target.selectedIndex;
    let label = e.nativeEvent.target[index].text;
    
    setEditSalesOrgCode(e.target.value)
    setEditSalesOrg(label)
  }

  const hasFilter = () => {
    try{
      let persisted = JSON.parse(localStorage.getItem('redux-mjbpt-filter'))
      console.log(persisted)
      return persisted
    }catch(e){ return null }
  }

  const handleResetTable = () => {
    dispatch(resetFilterMasterJBPType())
  }

  const handleExportData = async () => {
    if(loadingExport) return
    try {
      setLoadingExport(true)

      const response = await exportJbpTypes(filterMenu);

      const href = URL.createObjectURL(response.data)
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', `jbp-type.xlsx`)
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      setLoadingExport(false)
    } catch (error) {
      setLoadingExport(false)
      swal({
        title: t('Export Failed'),
        icon: 'error',
      })
    }
  }

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <>
            <SelectPageSize
              initialValue={filterMenu?.per_page ?? 5}
              onChange={(value: any) => handlePageSizeChange(value?.value)}
            />
            { hasFilter() && 
              <button type="button" onClick={() => handleResetTable()} className="btn btn-outline-danger btn-sm">Clear Filter</button> 
            }
          </>
        }
        rightContent={ <>
            <button disabled={loadingExport} onClick={handleExportData} className='btn btn-warning d-flex align-items-center'>
              {
                loadingExport ? <i className='fa fa-spinner fa-spin'></i> : <>
                  <i className='fa fa-download'></i>
                  <p>Export Data</p>
                </>
              }
            </button>
            { hakAkses?.create && (
              <button onClick={handleShow} className='btn btn-primary d-flex align-items-center'>
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                <p>{t('order-tambah') + ' ' + t('jbp-type')}</p>
              </button>
            )}
        </>
        }
      />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <tr>
              <th>{t('No')}</th>
              <th>{t('kode')}</th>
              {/* <th>{t('Sales Org Code')}</th> */}
              <th>{t('sub-order-produsen')}</th>
              <th>{t('jbp-type')}</th>
              <th>{t('order-aksi')}</th>
            </tr>
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilter />
            {loading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : jbpTypes?.length === 0 ? (
              <RowEmptyData />
            ) : (
              jbpTypes?.map((item: any, _index: number) => (
                <tr key={item?.code ?? _index}>
                  <td>{_index + 1 + rowNumber}</td>
                  <td>{item.code}</td>
                  {/* <td>{item.company_code}</td> */}
                  <td>{item.company_desc}</td>
                  <td>{item.type}</td>
                  <td>
                    <div>
                      {hakAkses?.update && (
                        <ActionIcon
                          className='me-1'
                          iconPath='/media/icons/duotune/pencil-fill.svg'
                          title={t('ubah')}
                          isLoading={isLoadingEditButton(_index)}
                          disabled={isLoadingEditButton(_index)}
                          onClick={() => {
                            onUpdateLoaderListByIndex(_index)
                            handleEdit(item.id)
                          }}
                        />
                      )}
                      {hakAkses?.delete && (
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                          title={t('Hapus')}
                          onClick={() => deleteMenu(item.id)}
                        >
                          <KTSVG
                            path='/media/icons/duotune/trash-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal show={show1} onHide={handleClose1} backdrop='static' keyboard={false} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t('ubah')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showSkeletonModal ? (
            <SkeletonForm />
          ) : (
            <>
            <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('Code')}</Form.Label>
            <Form.Control
              type='text'
              defaultValue={editCode}
              disabled
              placeholder={t('Code')}
            />
          </Form.Group>

              <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('TableBank.sales_org')}</Form.Label>
              <Form.Select
                defaultValue={editSalesOrgCode}
                aria-label='Default select example'
                onChange={handleSalesOrgEdit}
              >
                <option value=''>
                  {t('pilih')} {t('TableBank.sales_org')}
                </option>
                {salesOrgOptions?.map((item: any, index: number) => (
                  <option key={item?.value ?? index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('jbp-type')}</Form.Label>
            <Form.Control
              type='text'
              defaultValue={editJbpType}
              placeholder={t('jbp-type')}
              onChange={(e: any) => setEditJbpType(e.target.value)}
            />
          </Form.Group>
              
              <div className='d-flex justify-content-end'>
                <Button variant='primary' onClick={editMenu} disabled={btnLoading}>
                  {btnLoading ? (
                    <Spinner animation='border' variant='light' size='sm' />
                  ) : (
                    t('ubah')
                  )}
                </Button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={show} onHide={handleClose} backdrop='static' keyboard={false} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t('order-tambah')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('TableBank.sales_org')}</Form.Label>
            <Form.Select
              aria-label='Default select example'
              onChange={handleSalesOrg}
            >
              <option value=''>
                {t('pilih')} {t('TableBank.sales_org')}
              </option>
              {salesOrgOptions?.map((item: any, index: number) => (
                <option key={item?.value ?? index} value={item.value}>
                  {item.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('jbp-type')}</Form.Label>
            <Form.Control
              type='text'
              defaultValue={jbpType}
              placeholder={t('jbp-type')}
              onChange={(e: any) => setJbpType(e.target.value)}
            />
          </Form.Group>
          <div className='d-flex justify-content-end'>
            <Button variant='primary' onClick={postJbpType} disabled={btnLoading}>
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                t('order-tambah')
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {Table}
